"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-sixteen/section/heroSection.tsx */

import { HeaderSectionProps } from "@/Templates/SectionsProps";
import GeneratedHeaderSection from "../../Components/GeneratedHeaderSection";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HeroSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Personalized nutrition plan" | "Custom meal plans updated biweekly" | "Progress tracking & analytics" | "Private coaching sessions" | "Customized supplement protocol" | "Group coaching sessions" | "Initial health assessment" */
    h20Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h20ClassName?: string;
};
export type HomeSixteenHeroSectionGeneratedProps = {
    headerSectionProps?: HeaderSectionProps;
    divDiv0Div0Div0Div0ClassName?: string;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div0Div0A0AHref?: string;
    /** Default: "Claim Offer" */
    divDiv0Div0Div0Div0Div0Div0A0AText?: ReactNode;
    /** Default: "banner" */
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-17.png" */
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Special Launch Offer" */
    divDiv0Div0Div0Div0Div0Div0H20H2Text?: ReactNode;
    divDiv0Div0Div0Div0Div0Div0H20H2Visible?: boolean;
    divDiv0Div0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Sign up for any 3-month package this week and receive a FREE initial lab Session." */
    divDiv0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    divDiv0Div0Div0Div0Div2Div0DivDataWowDuration?: string;
    /** Default: "#" */
    divDiv0Div0Div0Div0Div2Div0A0AHref?: string;
    /** Default: "Get Started Today" */
    divDiv0Div0Div0Div0Div2Div0A0Span0SpanText?: ReactNode;
    /** Default: "Expert nutrition guidance and personalized wellness strategies to help you achieve lasting vitality." */
    divDiv0Div0Div0Div0Div2Div0P0PText?: ReactNode;
    /** Default: "1s" */
    divDiv0Div0Div0H10H1DataWowDuration?: string;
    /** Default: "Nourish Your Body," */
    divDiv0Div0Div0H10H1Text?: ReactNode;
    divDiv0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Transform Your Life" */
    divDiv0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "banner" */
    divDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "1s" */
    divDiv0ImageWithBasePath0ImageDataWowDuration?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-18.png" */
    divDiv0ImageWithBasePath0ImageSrc?: string;
    divDiv0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
    /** Default: "banner-img" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-16.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/shadow/banner-shadow-1.svg" */
    divImageWithBasePath1ImageSrc?: string;
    divImageWithBasePath1ImageVisible?: boolean;
    divImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/shadow/banner-shadow-2.svg" */
    divImageWithBasePath2ImageSrc?: string;
    divImageWithBasePath2ImageVisible?: boolean;
    divImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    divImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/shadow/banner-shadow-3.svg" */
    divImageWithBasePath3ImageSrc?: string;
    divImageWithBasePath3ImageVisible?: boolean;
    divImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "1s" */
    divSection0SectionDataWowDuration?: string;
    /** Default: "left" */
    divSection0Div0DivDataDirection?: string;
    /** Default: "slow" */
    divSection0Div0DivDataSpeed?: string;
    heroSectionServicesSlides: HeroSectionServicesSlidesItem[];
    heroSectionServicesSlidesItemWrapper?: (item: HeroSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    heroSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionServicesSlidesH2Visible?: boolean;
    heroSectionServicesSlidesH2Renderer?: (item: HeroSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    heroSectionServicesSlidesH2Props?: Partial<ComponentProps<"h2">> | ((item: HeroSectionServicesSlidesItem) => Partial<ComponentProps<"h2">>);
};

const HomeSixteenHeroSectionGenerated: FC<HomeSixteenHeroSectionGeneratedProps> = ({
    headerSectionProps,
    divDiv0Div0Div0Div0Div0Div0A0AHref = "#",
    divDiv0Div0Div0Div0Div0Div0A0AText = "Claim Offer",
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "banner",
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-17.png",
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div0Div0Div0DivDataWowDuration = "1s",
    divDiv0Div0Div0Div0Div0Div0H20H2Text = "Special Launch Offer",
    divDiv0Div0Div0Div0Div0Div0H20H2Visible,
    divDiv0Div0Div0Div0Div0Div0H20H2Renderer,
    divDiv0Div0Div0Div0Div0Div0H20H2Props,
    divDiv0Div0Div0Div0Div0Div0P0PText = "Sign up for any 3-month package this week and receive a FREE initial lab Session.",
    divDiv0Div0Div0Div0Div2Div0A0AHref = "#",
    divDiv0Div0Div0Div0Div2Div0A0Span0SpanText = "Get Started Today",
    divDiv0Div0Div0Div0Div2Div0DivDataWowDuration = "1s",
    divDiv0Div0Div0Div0Div2Div0P0PText = "Expert nutrition guidance and personalized wellness strategies to help you achieve lasting vitality.",
    divDiv0Div0Div0H10H1DataWowDuration = "1s",
    divDiv0Div0Div0H10H1Text = "Nourish Your Body,",
    divDiv0Div0Div0H10H1Visible,
    divDiv0Div0Div0H10H1Renderer,
    divDiv0Div0Div0H10H1Props,
    divDiv0Div0Div0H10Span0SpanText = "Transform Your Life",
    divDiv0ImageWithBasePath0ImageAlt = "banner",
    divDiv0ImageWithBasePath0ImageDataWowDuration = "1s",
    divDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-18.png",
    divDiv0ImageWithBasePath0ImageVisible,
    divDiv0ImageWithBasePath0ImageRenderer,
    divDiv0ImageWithBasePath0ImageProps,
    divImageWithBasePath0ImageAlt = "banner-img",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-16.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath1ImageAlt = "shadow",
    divImageWithBasePath1ImageSrc = "/Templates/Doccure/img/shadow/banner-shadow-1.svg",
    divImageWithBasePath1ImageVisible,
    divImageWithBasePath1ImageRenderer,
    divImageWithBasePath1ImageProps,
    divImageWithBasePath2ImageAlt = "shadow",
    divImageWithBasePath2ImageSrc = "/Templates/Doccure/img/shadow/banner-shadow-2.svg",
    divImageWithBasePath2ImageVisible,
    divImageWithBasePath2ImageRenderer,
    divImageWithBasePath2ImageProps,
    divImageWithBasePath3ImageAlt = "shadow",
    divImageWithBasePath3ImageSrc = "/Templates/Doccure/img/shadow/banner-shadow-3.svg",
    divImageWithBasePath3ImageVisible,
    divImageWithBasePath3ImageRenderer,
    divImageWithBasePath3ImageProps,
    divSection0Div0DivDataDirection = "left",
    divSection0Div0DivDataSpeed = "slow",
    divSection0SectionDataWowDuration = "1s",
    divH20H2Props,
    divDiv0Div0Div0Div0ClassName,
    heroSectionServicesSlides,
    heroSectionServicesSlidesItemWrapper,
    heroSectionServicesSlidesRenderer,
    heroSectionServicesSlidesH2Visible,
    heroSectionServicesSlidesH2Renderer,
    heroSectionServicesSlidesH2Props,
}) => {
    return (
        <div className="hero-section-sixteen">
            {headerSectionProps?.pageData ? <GeneratedHeaderSection pageData={headerSectionProps.pageData} setting={{ Appearance: { Id: -1, Name: "Home16", Key: CenterOptions.SiteTemplate.SiteTemplateSettings.SiteTemplateHeroAppearance.Home16.key, Priority: -1 }, HeroImage: { Id: -1, Name: "", Size: 0 }, HeroButtonDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoDisplayStatus: { Id: -1, Name: "", Key: "", Priority: -1 }, HeroVideoImage: { Id: -1, Name: "", Size: 0 }, HeroVideoLink: { Id: -1, Name: "", Size: 0 } }} lists={{ HeroAvatars: [], HeroStatistics: [], SideImages: [] }} /> : null}
            <div className="banner-section-sixteen">
                <div className="container">
                    <div className="banner-content">
                        {renderNode(divDiv0Div0Div0H10H1Visible, divDiv0Div0Div0H10H1Renderer, (
                            <h1 className="title wow fadeInUp" data-wow-duration={divDiv0Div0Div0H10H1DataWowDuration} {...(divDiv0Div0Div0H10H1Props ?? {})}>
                                {" "}
                                {divDiv0Div0Div0H10H1Text}
                                <span>{divDiv0Div0Div0H10Span0SpanText}</span>
                                {" "}
                            </h1>
                        ))}
                        <div className={divDiv0Div0Div0Div0ClassName ?? "row"}>
                            <div className="col-lg-3">
                                <div className="banner-item-sixteen wow fadeInUp" data-wow-duration={divDiv0Div0Div0Div0Div0Div0DivDataWowDuration}>
                                    <div className="banner-overlay">
                                        {renderNode(divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(divDiv0Div0Div0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </div>
                                    {renderNode(divDiv0Div0Div0Div0Div0Div0H20H2Visible, divDiv0Div0Div0Div0Div0Div0H20H2Renderer, (
                                        <h2 className="banner-title" {...(divDiv0Div0Div0Div0Div0Div0H20H2Props ?? {})}>{divDiv0Div0Div0Div0Div0Div0H20H2Text}</h2>
                                    ))}
                                    <p className="banner-description">{divDiv0Div0Div0Div0Div0Div0P0PText}</p>
                                    <a href={divDiv0Div0Div0Div0Div0Div0A0AHref} className="banner-link">{divDiv0Div0Div0Div0Div0Div0A0AText}</a>
                                </div>
                            </div>
                            <div className="col-lg-6" />
                            <div className="col-lg-3">
                                <div className="banner-text wow fadeInUp" data-wow-duration={divDiv0Div0Div0Div0Div2Div0DivDataWowDuration}>
                                    <p className="description">{divDiv0Div0Div0Div0Div2Div0P0PText}</p>
                                    <a href={divDiv0Div0Div0Div0Div2Div0A0AHref} className="theme-16-btn">
                                        <span className="text">
                                            {" "}
                                            {divDiv0Div0Div0Div0Div2Div0A0Span0SpanText}
                                            <i className="isax isax-arrow-right-25" />
                                        </span>
                                        <span className="buble buble-1" />
                                        <span className="buble buble-2" />
                                        <span className="buble buble-3" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(divDiv0ImageWithBasePath0ImageVisible, divDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={divDiv0ImageWithBasePath0ImageSrc} alt={divDiv0ImageWithBasePath0ImageAlt} className="img-fluid element-one d-none d-lg-block wow zoomIn" data-wow-duration={divDiv0ImageWithBasePath0ImageDataWowDuration} {...(divDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
            </div>
            <section className="slider-section-sixteen wow fadeInDown" data-wow-duration={divSection0SectionDataWowDuration}>
                <div className="horizontal-slide slide-sixteen d-flex" data-direction={divSection0Div0DivDataDirection} data-speed={divSection0Div0DivDataSpeed}>
                    <div className="slide-list d-flex gap-4">
                        {renderCollectionNode(
                            heroSectionServicesSlides,
                            (item: HeroSectionServicesSlidesItem) => (
                                <div className={item.className ?? "services-slide"} key={item.key}>
                                    {renderItemNode(heroSectionServicesSlidesH2Visible, heroSectionServicesSlidesH2Renderer, item, (
                                        <h2 className={item.h20ClassName ?? "title"} {...(typeof heroSectionServicesSlidesH2Props === "function" ? heroSectionServicesSlidesH2Props(item) : (heroSectionServicesSlidesH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>{item.h20Text}</h2>
                                    ))}
                                </div>
                            ),
                            heroSectionServicesSlidesItemWrapper,
                            heroSectionServicesSlidesRenderer
                        )}
                    </div>
                </div>
            </section>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid banner-img" {...(divImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath1ImageVisible, divImageWithBasePath1ImageRenderer, (
                <SmartImage src={divImageWithBasePath1ImageSrc} alt={divImageWithBasePath1ImageAlt} className="img-fluid shadow-one" {...(divImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath2ImageVisible, divImageWithBasePath2ImageRenderer, (
                <SmartImage src={divImageWithBasePath2ImageSrc} alt={divImageWithBasePath2ImageAlt} className="img-fluid shadow-two" {...(divImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(divImageWithBasePath3ImageVisible, divImageWithBasePath3ImageRenderer, (
                <SmartImage src={divImageWithBasePath3ImageSrc} alt={divImageWithBasePath3ImageAlt} className="img-fluid shadow-three" {...(divImageWithBasePath3ImageProps ?? {})} />
            ))}
        </div>
    );
};

export default HomeSixteenHeroSectionGenerated;
